<template>
  <div class="main miny-100vh o-hidden display-flex align-center justify-center">
    <v-card
      max-width="500"
      style="flex-grow: 1"
      class="ma-3"
    >
      <v-card-title class="subtitle-1">
        Inactive Account
      </v-card-title>
      <v-card-text v-show="(appUserLoaded && accountLoaded || permissionDenied)">
        <p v-if="account.type === 'individual' || permissionDenied">
          This account is no longer active.
        </p>
        <template v-else>
          <template v-if="!accountActive">
            <p>The '{{ account.name }}' account is no longer active.</p>
          </template>
          <template v-else-if="!appUserActive">
            <p>This user account is no longer active.</p>
            <p>Please contact an '{{ account.name }}' account admin for help or to reactivate your account.</p>
          </template>
        </template>
        <p v-show="(account.type === 'individual' && !appUserActive) || !accountActive">
          Please contact <support-link subject="Reactivate Account" /> for help or to reactivate your account.
        </p>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          color="primary"
          small
          text
          @click="logout"
        >
          Logout
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import SupportLink from '../components/SupportLink.vue'

export default {
  name: 'InactiveAccount',
  components: { SupportLink },
  data: function () {
    return {
      appUserActive: null,
      accountActive: null
    }
  },
  computed: {
    permissionDenied() {
      return 'permission-denied' in this.$route.query
    }
  },
  watch: {
    'accountLoaded': {
      handler: function (newVal, oldVal) {
        if (newVal) {
          this.accountActive = this.account.active
          this.redirectIfActive()
        }
      },
      immediate: true
    },
    'appUserLoaded': {
      handler: function (newVal, oldVal) {
        if (newVal) {
          this.appUserActive = this.appUser.active
          this.redirectIfActive()
        }
      },
      immediate: true
    },
    'permissionDenied': {
      handler: function (newVal, oldVal) {
        if (newVal) {
          this.appUserActive = false
        }
      },
      immediate: true
    }
  },
  beforeCreate() {
    this.dispatchActions(['get_appUser', 'get_account'])
    this.mapStates(['appUser', 'account'])
    this.mapGetters(['appUserLoaded', 'accountLoaded'])
  },
  methods: {
    redirectIfActive() {
      if (this.accountActive && this.appUserActive) {
        this.$router.replace('/dashboard')
      }
    },
    logout() {
      this.$store.dispatch('LOGOUT')
      this.$router.replace('/')
    }
  }

}
</script>

<style scoped>

</style>
